module.exports = __webpack_public_path__ + "img/under_construction.7a29f54c.svg";